<template>
  <div>This is footer &copy; Footer</div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped></style>
